<template>
  <div
    class="activity-page"
    @click="handleBlurInput"
    :style="{ paddingTop: isProvinceFilter ? '0.43rem' : '' }"
  >
    <div
      class="activity-inner"
      :class="{ 'padding-for-sky-nav': activitySuffix === 'cfdeb7' }"
    >
      <ProvinceSelect
        v-if="isProvinceFilter"
        @on-select-province="handleSelectProvince"
        :provinceCode="provinceSelectInfo.provinceCode"
        :visible.sync="provinceSelectInfo.visible"
      ></ProvinceSelect>
      <div v-for="(item, index) in activityInfo.activity_floor" :key="index">
        <ActivityFloor
          :activityFloor="item"
          @get-coupon="getCoupon"
        ></ActivityFloor>
      </div>
      <sky-tone-nav v-if="activitySuffix === 'cfdeb7'"></sky-tone-nav>
    </div>

    <CommonDialog
      v-model="inputPhone.visible"
      :hideHeader="true"
      ref="phoneInputDialog"
    >
      <div class="input-phone-dialog">
        <div class="input-phone-dialog-header">
          <div class="input-phone-dialog-header-icon">
            <img src="../../assets/imgs/pdv-logo.png" />
          </div>
          <div class="input-phone-dialog-header-info">
            <div class="info-title">熊猫签证</div>
            <div class="info-sub-title">足不出户办签证</div>
          </div>
        </div>
        <div class="input-phone-dialog-content">
          <div class="content-input-box">
            <!-- 隐藏真实的Input，解决ios光标错位问题 -->
            <label class="input-label">
              <div
                class="input-value"
                :class="{ placeholder: !inputPhone.phone }"
              >
                <div class="cursor" v-show="uiControls.phoneShow"></div>
                {{ inputPhone.phone || '输入手机号' }}
              </div>
              <input
                ref="phoneInput"
                maxlength="11"
                v-model="inputPhone.phone"
                class="activity-input"
                type="text"
                placeholder="输入手机号"
                @focus="uiControls.phoneShow = true"
                @blur="uiControls.phoneShow = false"
              />
            </label>
          </div>
          <div class="content-input-button">
            <button @click="submitPhone" class="activity-btn">
              领取优惠券
            </button>
          </div>
        </div>
      </div>
    </CommonDialog>
    <CommonDialog v-model="registerPhone.visible" :hideHeader="true">
      <div class="register-phone-dialog">
        <div class="register-phone-dialog-header">
          <div class="register-phone-dialog-header-icon">
            <img src="../../assets/imgs/pdv-logo.png" />
          </div>
          <div class="register-phone-dialog-header-info">
            <div class="info-title">熊猫签证</div>
            <div class="info-sub-title">足不出户办签证</div>
          </div>
        </div>
        <div class="register-phone-dialog-content">
          <div class="register-phone-label">
            验证码已发送至 <span>{{ inputPhone.phone }}</span>
          </div>
          <div class="content-input-box">
            <!-- 隐藏真实的Input，解决ios光标错位问题 -->
            <label class="input-label">
              <div
                class="input-value"
                :class="{ placeholder: !registerPhone.code }"
              >
                <div class="cursor" v-show="uiControls.codeShow"></div>
                {{ registerPhone.code || '输入验证码' }}
              </div>
              <input
                ref="codeInput"
                v-model="registerPhone.code"
                class="activity-input"
                type="text"
                placeholder="输入验证码"
                @focus="uiControls.codeShow = true"
                @blur="uiControls.codeShow = false"
              />
            </label>
            <div class="input-footer">
              <span
                @click="sendPhoneCode"
                class="get-code"
                v-if="registerPhone.time <= 0"
                >获取验证码</span
              >
              <span class="code-time" v-else>{{ registerPhone.time }}s</span>
            </div>
          </div>
          <div class="content-input-button">
            <button
              @click="submitRegisterUser"
              :disabled="!registerPhone.code"
              class="activity-btn"
            >
              领取优惠券
            </button>
          </div>
          <div class="register-protocol">
            注册代表您已阅读并同意
            <a @click="registerPhone.protocolVisible = true"
              >熊猫签证用户协议</a
            >
          </div>
        </div>
      </div>
    </CommonDialog>
    <CommonDialog
      v-model="registerPhone.protocolVisible"
      :hideHeader="true"
      :z-index="1002"
    >
      <div
        style="
          height: 3.7rem;
          width: 100%;
          -webkit-overflow-scrolling: touch;
          overflow-y: scroll;
        "
      >
        <iframe
          style="height: 100%; width: 100%"
          src="https://h5.11visa.com/#/policy"
        ></iframe>
      </div>
    </CommonDialog>
  </div>
</template>

<script>
import ActivityFloor from './components/activity-floor.vue';
import ProvinceSelect from './components/province-select.vue';
import CommonDialog from './components/common-dialog';
import ActivityService from '../../services/activityService.js';
import toast from '../../services/toast.js';
import activityToast from './activity-toast.js';
import utils from '../../services/tools.js';
import skyToneNav from './components/sky-tone-nav';

export default {
  name: 'Activity',
  components: {
    skyToneNav,
    ActivityFloor,
    ProvinceSelect,
    CommonDialog,
  },
  data() {
    return {
      activityService: new ActivityService(this.$http),
      isProvinceFilter: false, // 是否需要过滤省份
      activitySuffix: '', // 活动后缀
      is_in_app: 0, // 是否在APP内
      phone: '', // 用户手机号
      activityInfo: {},
      uiControls: {
        phoneShow: false,
        codeShow: false,
      },
      couponCode: '', // 当前领取的code
      provinceSelectInfo: {
        // 省份选择组件
        visible: false,
        provinceCode: '0',
      },
      inputPhone: {
        // 输入手机号弹窗
        visible: false,
        phone: '',
      },
      registerPhone: {
        // 注册弹窗（输入手机验证码）
        visible: false,
        code: '',
        time: 0,
        protocolVisible: false,
      },
    };
  },
  watch: {
    $route() {
      if (this.$route.params.activitySuffix !== this.activitySuffix) {
        this.$router.go(0);
      }
    },
  },
  created() {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    });
    utils.bridgeInit();
    this.initRegisterBridge();
    this.is_in_app = this.$route.query.is_in_app || 0;
    this.activitySuffix = this.$route.params.activitySuffix;
    this.provinceSelectInfo.provinceCode = this.$route.query.province_id || '0';
    if (this.isPhoneValid(this.$route.query.mobile_phone)) {
      this.phone = this.$route.query.mobile_phone || '';
    }
    this.getActivity();
  },
  methods: {
    initRegisterBridge() {
      utils.getBridge((bridge) => {
        // 给app调用,给H5当前登录的手机号
        bridge.registerHandler('mobile_phone', (data) => {
          if (data) {
            this.phone = data;
            this.addQueryToUrl('mobile_phone', this.phone);
          }
        });
      });
    },
    handleBlurInput(e) {
      if (
        e.target.tagName !== 'INPUT' &&
        this.$refs.phoneInput &&
        this.uiControls.phoneShow
      ) {
        this.$refs.phoneInput.blur();
      }
      if (
        e.target.tagName !== 'INPUT' &&
        this.$refs.codeInput &&
        this.uiControls.codeShow
      ) {
        this.$refs.codeInput.blur();
      }
    },
    handleSelectProvince(code) {
      this.provinceSelectInfo.provinceCode = code;
      this.getActivity(); // 切换了省份，重新请求一下数据
      this.addQueryToUrl('province_id', code);
    },
    // 往当前URL里面添加query参数
    addQueryToUrl(key, value) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query[key] = value;
      // const location = {
      //   path,
      //   query,
      // };
      let queryString = '';
      Object.keys(query).forEach((key) => {
        queryString += `${key}=${query[key]}&`;
      });
      queryString = queryString.substring(0, queryString.length - 1);
      window.location.replace(
        `${window.location.origin}/#${this.$route.path}?${queryString}`,
      );
      // this.$router.replace(location);
    },
    setHtmlTitle(title) {
      document.title = title;
    },
    getActivity() {
      this.activityInfo = {};
      this.activityService
        .getActivityDetali(
          this.activitySuffix,
          this.provinceSelectInfo.provinceCode,
          this.phone,
        )
        .then((data) => {
          if (data && data.body && data.body.body) {
            const activityInfo = data.body.body;
            if (activityInfo.product_filter === 1) {
              this.isProvinceFilter = true;
            }
            this.activityInfo = activityInfo;
            this.setHtmlTitle(activityInfo.public_title);
          } else if (data.body.ret === -1) {
            // 服务器报错，展示错误信息
            toast.show(data.body.msg);
            this.$router.replace('/activity-404');
          } else if (data.body.ret === -3) {
            // 活动已下架
            this.$router.replace('/activity-404');
          } else if (data.body.ret === -2) {
            // 需要省份筛选
            this.isProvinceFilter = true;
            this.provinceSelectInfo.visible = true;
          }
        })
        .catch(() => {
          toast.show('服务器故障');
          this.$router.replace('/activity-404');
        });
    },
    getCoupon(code, couponInfo) {
      this.couponCode = code;
      this.couponInfo = couponInfo;
      if (this.phone) {
        this.submitGetCoupon();
      } else if (this.is_in_app) {
        utils.getBridge((bridge) => {
          bridge.callHandler('open_login', {}, () => {});
        });
      } else {
        //= =====   如果需要进行不同端进行对应端的登录页面，在此处理跳转对应的登录页面
        this.inputPhone.visible = true;
      }
    },
    /**
     * 手机号是否合法
     */
    isPhoneValid(phone) {
      return /^1[0-9]{10}$/.test(phone);
    },
    submitPhone() {
      if (this.isPhoneValid(this.inputPhone.phone)) {
        // this.phone = this.inputPhone.phone;
        this.inputPhone.visible = false;
        this.submitGetCoupon();
      } else {
        toast.show('请输入合法的手机号');
      }
    },
    submitGetCoupon() {
      this.activityService
        .userCouponReceive(this.couponCode, this.inputPhone.phone || this.phone)
        .then((data) => {
          if (data && data.body && data.body.body) {
            activityToast.show('领取成功', 'success');
            this.couponInfo.status = 2;
            if (this.inputPhone.phone) {
              this.phone = this.inputPhone.phone;
            }
            this.addQueryToUrl('mobile_phone', this.phone);
          } else if (data.body.ret === -1) {
            // 服务器报错，展示错误信息
            toast.show(data.body.msg);
          } else if (data.body.ret === -2) {
            if (this.phone) {
              this.inputPhone.phone = this.phone;
            }
            // 用户未注册
            this.registerPhone.visible = true;
            this.phoneCodeTimeCount();
          } else if (data.body.ret === -3) {
            // 已领取
            this.couponInfo.status = 2;
            activityToast.show('领过咯', 'get');
            if (this.inputPhone.phone) {
              this.phone = this.inputPhone.phone;
            }
            this.addQueryToUrl('mobile_phone', this.phone);
          } else if (data.body.ret === -4) {
            // 领取完了
            this.couponInfo.status = 0;
            activityToast.show('抢光了', 'error');
            if (this.inputPhone.phone) {
              this.phone = this.inputPhone.phone;
            }
            this.addQueryToUrl('mobile_phone', this.phone);
          }
        });
    },
    sendPhoneCode() {
      this.activityService.sendPhoneCode(this.inputPhone.phone).then((data) => {
        if (data && data.body && data.body.ret === 0) {
          this.phoneCodeTimeCount();
        } else if (data.body.ret === -1) {
          toast.show(data.body.msg);
        }
      });
    },
    phoneCodeTimeCount() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.registerPhone.time = 60;
      this.timer = setInterval(() => {
        this.registerPhone.time -= 1;
        if (this.registerPhone.time <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    submitRegisterUser() {
      this.activityService
        .registerUser(this.inputPhone.phone, this.registerPhone.code)
        .then((data) => {
          if (data && data.body && data.body.body) {
            this.registerPhone.visible = false;
            // 已领取
            this.phone = this.inputPhone.phone;
            this.couponInfo.status = 2;
            activityToast.show('领取成功', 'success');
            // this.submitGetCoupon();
          } else if (data.body.ret === -1) {
            toast.show(data.body.msg);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.activity-input {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 0.45rem;
  line-height: 0.45rem;
  outline: none;
  padding: 0 0.15rem;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.activity-btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 0.15rem 0.2rem;
  width: 100%;
  font-size: 0.14rem;
  border-radius: 0.04rem;
  &:active {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
.activity-page {
  min-height: 100%;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .activity-inner {
    &.padding-for-sky-nav {
      padding-bottom: 0.55rem;
    }
  }
}
.input-phone-dialog,
.register-phone-dialog {
  .input-phone-dialog-header,
  .register-phone-dialog-header {
    display: flex;
    justify-content: center;
    align-items: center;
    .input-phone-dialog-header-icon,
    .register-phone-dialog-header-icon {
      width: 0.43rem;
      height: 0.43rem;
      margin-right: 0.1rem;
      img {
        width: 0.43rem;
        height: 0.43rem;
      }
    }
    .input-phone-dialog-header-info,
    .register-phone-dialog-header-info {
      line-height: 1;
      .info-title {
        color: #444444;
        font-size: 0.16rem;
        margin-bottom: 0.1rem;
      }
      .info-sub-title {
        color: #aaaaaa;
        font-size: 0.12rem;
      }
    }
  }
}
.input-phone-dialog {
  .input-phone-dialog-content {
    padding: 0 0.1rem;
    margin-top: 0.25rem;
    .content-input-box {
      margin-bottom: 0.15rem;
      .activity-input {
        border: solid 1px #ec6665;
      }
    }
    .content-input-button {
      .activity-btn {
        background-image: linear-gradient(
            -30deg,
            rgba(235, 85, 95, 0.8) 0%,
            rgba(237, 110, 92, 0.8) 100%
          ),
          linear-gradient(#ec6665, #ec6665);
        border: none;
        color: #fff;
        font-size: 0.15rem;
      }
    }
  }
}
.register-phone-dialog {
  .register-phone-dialog-content {
    padding: 0 0.1rem;
    margin-top: 0.25rem;
    text-align: left;
    .register-phone-label {
      font-size: 0.14rem;
      color: #aaa;
      margin-bottom: 0.15rem;
      span {
        color: #444444;
      }
    }
    .content-input-box {
      position: relative;
      margin-bottom: 0.15rem;
      .activity-input {
        border: solid 1px #ec6665;
        padding-right: 0.9rem;
      }
      .input-footer {
        z-index: 999;
        width: 0.9rem;
        position: absolute;
        right: 0;
        height: 100%;
        top: 0;
        color: #ff5a60;
        font-size: 0.14rem;
        padding-right: 0.1rem;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .code-time {
          color: rgba(255, 90, 96, 0.5);
        }
        span {
          z-index: 999;
        }
      }
    }
    .content-input-button {
      margin-bottom: 0.15rem;
      .activity-btn {
        background-image: linear-gradient(
            -30deg,
            rgba(235, 85, 95, 0.8) 0%,
            rgba(237, 110, 92, 0.8) 100%
          ),
          linear-gradient(#ec6665, #ec6665);
        border: none;
        color: #fff;
        font-size: 0.15rem;
        &:disabled {
          background: #ffa8ab;
        }
      }
    }
    .register-protocol {
      font-size: 0.12rem;
      color: #aaa;
      a {
        color: #444444;
        text-decoration: underline;
      }
    }
  }
}
.input-label {
  position: relative;
  z-index: 2;
  display: block;
  border: solid 1px #ec6665;
  padding-right: 0.9rem;
  border-radius: 0.03rem;
  input {
    transform-origin: 0 70%;
    transform: scale(0.00001);
  }
}

.input-value {
  position: absolute;
  left: 0.18rem;
  top: 0.16rem;
  z-index: 50;
  text-align: left;
  font-size: 0.14rem;
  color: #333;

  .cursor {
    display: block;
    position: absolute;
    right: -2px;
    width: 2px;
    height: 0.16rem;
    top: 0rem;
    background-color: #666;
    animation: login-cursor 1000ms infinite;
  }

  &.placeholder {
    color: #aaa;

    .cursor {
      left: -1px;
    }
  }
}
@keyframes login-cursor {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
